import React, { FC, useContext, useState, useEffect } from 'react';
import styles from './LogIn.module.scss';
import { LogoDark } from 'esa-ui-library';
import { LogInForm } from './components';
import { EmailForm } from '../../components';
import { FORGOT_EXPLANATION } from '../../constants';
import { getUrlParam, useStore } from '../../../common';
import { AuthContext } from '../../../logic';

const LogIn: FC = (): JSX.Element => {
	const [, dispatch] = useStore(false);
	const { login } = useContext(AuthContext);
	const [isForgot, setIsForgot] = useState(false);
	const token = getUrlParam('token');

	useEffect(() => {
		if (token) {
			dispatch('LOGIN_SUBMIT', login);
		}
	}, [dispatch, login, token]);

	const onLoginSubmit = () => {
		dispatch('LOGIN_SUBMIT', login);
	};

	const onForgotSubmit = () => {
		dispatch('FORGOT_SUBMIT');
	};

	return (
		<section className={styles.Login}>
			<section>
				<LogoDark />
				<div className={styles.LoginContent}>
					<h2>{isForgot ? 'Forgot Password' : 'Welcome Back'}</h2>
					<p className={styles.Explanation}>
						{isForgot ? FORGOT_EXPLANATION : 'Sign in to continue to use backoffice services.'}
					</p>
					{isForgot ? (
						<EmailForm isForgot={true} onSubmit={onForgotSubmit} onBack={() => setIsForgot(false)} />
					) : (
						!token && <LogInForm onSubmit={onLoginSubmit} onForgot={() => setIsForgot(true)} />
					)}
				</div>
			</section>
		</section>
	);
};

export { LogIn };
